import React from 'react';
import '../../assets/css/spinner.css';
import NoBudgetsMessage from './NoBudgetsMessage';

const GroupedBudgetsTable = props => {
  const getHasContractIcon = row => {
    if (row.HasContract) {
      return (
        <td className="icon icon--check u-brand-primary-color u-icon-size-normal" />
      );
    } else {
      return (
        <td className="icon icon--minus u-disabled-color u-icon-size-normal" />
      );
    }
  };

  if (!props.loading) {
    return props.rows.length > 0 ? (
      <div>
        <table className="table">
          <caption
            style={{ textAlign: 'center', paddingBottom: '15px' }}
            className="table__caption"
          >
            Presupuestos Enviados 
          </caption>
          <tbody>
            {props.rows.map((row, i) => (
              <tr key={i}>
                <td className="u-only-up-mobile">{i + 1}</td>
                {row.AgentId && (
                <td className="u-font-bold">
                  {row.Name} {row.Surname}
                </td>
                )}
                {row.Product && (
                  <td>{row.Product}</td>
                )}
                {row.HasContract !== undefined ? getHasContractIcon(row) : null}
                <td>{row.Ammount}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="u-text-center u-margin-top">
          {props.showMore && (
            <button
              className={`button button--primary ${
                props.isLoadingMore ? 'is-loading' : null
              }`}
              onClick={props.onLoadMore}
            >
              Cargar más
            </button>
          )}
        </div>
      </div>
    ) : (
      <NoBudgetsMessage />
    );
  } else {
    return <div className="spinner" style={{ maxWidth: 450, height: 450 }} />;
  }
};

export default GroupedBudgetsTable;



// WEBPACK FOOTER //
// ./src/components/SentBudgets/GroupedBudgetsTable.js